import PropTypes from 'prop-types';
import { getFilterUriType, getNavLinks } from '../sitemapHelpers.js';

// components
import { Link } from 'dibs-elements/exports/Link.tsx';

// styles
import styles from '../styles/navigation.scss';

export const SitemapNavigation = ({ vertical, filterType }) => {
    const filterUriSegment = getFilterUriType(filterType);
    const currentUrl = `/sitemap/${vertical}/${filterUriSegment}/`;
    const staticLinks = getNavLinks(vertical);
    return (
        <ul className={styles.navigationList}>
            {staticLinks.map(({ href, title }) => {
                return (
                    <li key={href} className={styles.linkWrapper}>
                        <Link
                            href={href}
                            className={`${styles.link} ${
                                href === currentUrl ? styles.activeLink : ''
                            }`}
                        >
                            {title}
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

SitemapNavigation.propTypes = {
    vertical: PropTypes.string.isRequired,
    filterType: PropTypes.string.isRequired,
};
